// extracted by mini-css-extract-plugin
export default {"container":"M1-z"};